<template>
  <div>
    <div class="card card-custom gutter-b example example-compact">
      <div class="card-header">
        <div class="card-title">
          <h3>Bestellungen</h3>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive mt-5">
          <v-simple-table class="record-table">
            <thead>
              <tr>
                <th class="text-center align-middle">Seriennummer</th>
                <th class="text-center align-middle">Rechnungsnummer</th>
                <th class="text-center align-middle">Kundenname</th>
                <th class="text-center align-middle">Bestelldatum</th>
                <th class="text-center align-middle">Preis</th>
                <th class="text-center align-middle">Bestellung versendet</th>
                <th class="text-center align-middle">Storniert</th>
                <th class="text-center align-middle">Aktionen</th>
              </tr>
            </thead>
            <tr>
              <td></td>
              <td>
                <div class="search-input-div">
                  <v-text-field
                    dense
                    autocomplete="new-password"
                    v-model.lazy="searchInvoiceKey"
                    solo
                    label="Rechnungsnummer suchen..."
                    clearable
                  ></v-text-field>
                </div>
              </td>
              <td>
                <div class="search-input-div">
                  <v-text-field
                    dense
                    autocomplete="new-password"
                    v-model.lazy="searchNameKey"
                    solo
                    label="Name suchen..."
                    clearable
                  ></v-text-field>
                </div>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                <div class="search-input-div">
                  <v-select
                    :items="statusCancelItems"
                    v-model="searchCancelStatusKey"
                    item-text="title"
                    item-value="value"
                    label="Status suchen..."
                    solo
                    clearable
                  />
                </div>
              </td>
              <td></td>
            </tr>
            <tbody v-if="orders.length">
              <tr v-for="(order, i) in orders" :key="order.id">
                <td
                  class="align-middle text-center clickable-td"
                  @click="goToDetails(order.id)"
                >
                  {{ i + 1 }}
                </td>
                <td class="align-middle clickable-td" @click="goToDetails(order.id)">
                  {{ order.invoice_no }}
                </td>
                <td
                  v-if="order.customer_first_name"
                  class="align-middle clickable-td"
                  @click="goToDetails(order.id)"
                >
                  {{
                    order.customer_company_name
                      ? order.customer_company_name
                      : order.customer_first_name + " " + order.customer_last_name
                  }}
                </td>
                <td
                  v-else
                  class="align-middle clickable-td"
                  @click="goToDetails(order.id)"
                >
                  -
                </td>
                <td class="align-middle clickable-td" @click="goToDetails(order.id)">
                  {{ order.order_date }}
                </td>
                <td class="align-middle clickable-td" @click="goToDetails(order.id)">
                  {{ order.amount | priceFormat }} {{ currencySybmol }}
                </td>
                <td class="text-center clickable-td">
                  <input
                    type="checkbox"
                    name="order_shipped"
                    :v-model="'order_shipped' + order.id"
                    @change="changeShippingStatus(order.id, order.is_shipped)"
                    :checked="order.is_shipped == '1' ? true : false"
                    :id="'shipped_' + order.id"
                  />
                </td>
                <td class="text-center clickable-td">
                  <input
                    type="checkbox"
                    name="order_cancelled"
                    :v-model="'order_cancelled' + order.id"
                    :checked="order.order_status == '2' ? true : false"
                    :id="'cancelled_' + order.id"
                    disabled=""
                  />
                </td>
                <td class="align-middle icon-wrapper-block">
                  <a @click="goToDetails(order.id)">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="search"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Bestellung ansehen</span>
                    </v-tooltip>
                  </a>
                  <a :href="order.order_bill" target="_blank">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="file-earmark"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Download Lieferschein</span>
                    </v-tooltip>
                  </a>
                  <a :href="order.invoice" target="_blank">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="file-earmark"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Download Rechnung</span>
                    </v-tooltip>
                  </a>
                  <span v-if="order.cancelled_invoice">
                    <a :href="order.cancelled_invoice" target="_blank">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <b-icon
                            v-bind="attrs"
                            v-on="on"
                            icon="file-earmark"
                            scale="1.3"
                            aria-hidden="true"
                          ></b-icon>
                        </template>
                        <span>Download Stornorechnung</span>
                      </v-tooltip>
                    </a>
                  </span>
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="loading_orders" class="loading-tbody">
              <td class="text-center" colspan="10">
                Wird geladen...
                <b-spinner variant="primary" label="Text Centered"></b-spinner>
              </td>
            </tbody>
            <tbody v-else class="loading-tbody">
              <tr>
                <td class="text-center" colspan="10">Keine Einträge gefunden</td>
              </tr>
            </tbody>
          </v-simple-table>
          <div class="d-flex pagination-block">
            <b-pagination
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total-rows="pagination.paginationRows"
              prev-text="Voriges"
              next-text="Nächstes"
              first-number
              last-number
              @change="paginationChange"
            >
              <template #prev-text
                ><span
                  ><b-icon
                    icon="chevron-left"
                    aria-hidden="true"
                    rel="prev"
                  ></b-icon></span
              ></template>
              <template #next-text
                ><span
                  ><b-icon
                    icon="chevron-right"
                    aria-hidden="true"
                    rel="next"
                  ></b-icon></span
              ></template>
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="showFileModal" class="file-modal" centered hide-footer resizable>
      <div v-if="modalFile">
        <div>
          <b-img :src="modalFile" class="modal-image"></b-img>
        </div>
      </div>
    </b-modal>
    <v-dialog v-model="statusDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2"> Bitte bestätigen </v-card-title>

        <v-card-text>
          <span>Wollen Sie den Status wirklich ändern?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn :disabled="disabledCancel" class="no-button" @click="hideModal">
            Nein
          </v-btn>
          <v-btn
            type="submit"
            @click="changeStatusRecord(statusRecordId, newStatus)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2"> Bitte bestätigen </v-card-title>

        <v-card-text>
          <span>Wollen Sie den Eintrag wirklich löschen?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn :disabled="disabledCancel" class="no-button" @click="hideModal">
            Nein
          </v-btn>
          <v-btn
            type="submit"
            @click="deleteRecord(deleteRecordId)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <notifications group="orders" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import HtmlClass from "@/core/services/htmlclass.service";
import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Notifications from "vue-notification";
import Loader from "@/components/admin/layout/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import providerAPI from "@/api/provider";
import config from "@/config/app.js";

Vue.use(Notifications);

export default {
  name: "Orders",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.userId = localStorage.getItem("bar_book_a_order_user_access_id");
      this.getOrders();
    }
  },
  data() {
    return {
      currencySybmol: config.CURRENCY_SYMBOL,
      loading_orders: true,
      filter: {
        orderCol: "id",
        orderBy: "desc",
      },
      searchNameKey: "",
      searchInvoiceKey: "",
      searchAddressKey: "",
      searchPriceKey: "",
      searchStatusKey: "",
      searchCancelStatusKey: "",
      statusCancelItems: [
        {
          title: "storniert",
          value: "1",
        },
        {
          title: "nicht storniert",
          value: "0",
        },
      ],
      userId: null,
      showFileModal: false,
      order_shipped: false,
      modalFile: null,
      orders: [],
      statusDialog: false,
      deleteDialog: false,
      deleteRecordId: null,
      statusRecordId: null,
      yesActionLoading: false,
      disabledCancel: false,
      newStatus: null,
      pagination: {
        currentPage: 1,
        perPage: 20,
        paginationRows: "",
      },
    };
  },
  components: {
    // 'money-format': MoneyFormat
  },
  watch: {
    searchNameKey: {
      handler: function (val, oldVal) {
        this.orders = [];
        this.loading_orders = true;
        this.getOrders();
      },
      deep: true,
    },
    searchCancelStatusKey: {
      handler: function (val, oldVal) {
        this.orders = [];
        this.loading_orders = true;
        this.getOrders();
      },
      deep: true,
    },
    searchInvoiceKey: {
      handler: function (val, oldVal) {
        this.orders = [];
        this.loading_orders = true;
        this.getOrders();
      },
      deep: true,
    },
  },
  methods: {
    goToDetails(id) {
      this.$router.push({
        path: "/dealer/order/" + btoa(parseInt(id)),
        target: "_blank",
      });
    },
    changeShippingStatus(orderId, shipped_status) {
      shipped_status = shipped_status == "0" ? "1" : "0";
      this.loading_orders = true;
      let data = { order_id: orderId, shipped_status: shipped_status };
      providerAPI
        .updateShippingStatus(data)
        .then((response) => {
          if (response.status == "success") {
            this.loading_orders = false;
            this.$notify({
              group: "orders",
              type: "success",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
            this.getOrders();
          }
        })
        .catch((err) => {
          // console.log(err);
          this.loading_orders = true;
        });
    },
    goToAddNew() {
      this.$router.push({ name: "add-order" });
    },
    hideModal() {
      this.statusDialog = false;
      this.yesActionLoading = false;
      this.deleteDialog = false;
    },
    sortListing(orderCol, orderBy) {
      if (!this.loading_orders) {
        this.orders = [];
        this.filter.orderCol = orderCol;
        this.filter.orderBy = orderBy;
        this.pagination.currentPage = 1;
        this.loading_orders = true;
        this.getOrders();
      }
    },
    paginationChange() {
      this.orders = [];
      this.loading_orders = true;
      setTimeout(() => {
        this.getOrders();
      }, 100);
    },
    getOrders() {
      let data = {
        user_id: this.currentUser.id,
        page: this.pagination.currentPage,
        search_order_name_field: this.searchNameKey,
        search_invoice_field: this.searchInvoiceKey,
        search_cancel_status_field: this.searchCancelStatusKey,
        per_page: this.pagination.perPage,
        sort_column: this.filter.orderCol,
        sort_type: this.filter.orderBy,
      };

      providerAPI
        .getOrders(data)
        .then((response) => {
          if (response.status == "success") {
            this.orders = response.data;
            this.pagination.paginationRows = response.count;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.loading_orders = false;
          } else {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.loading_orders = false;
            this.$notify({
              group: "orders",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.loading_orders = false;
          this.$notify({
            group: "orders",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    deleteorder(id) {
      this.deleteDialog = true;
      this.deleteRecordId = id;
    },
    deleteRecord(id) {
      this.disabledCancel = true;
      this.yesActionLoading = true;
      adminAPI
        .deleteorder({ id: id })
        .then((response) => {
          if (response.status == "success") {
            this.deleteDialog = false;
            this.deleteRecordId = null;
            this.disabledCancel = false;
            this.yesActionLoading = false;
            this.$notify({
              group: "orders",
              type: "success",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
            this.pagination.currentPage = 1;
            this.getOrders();
          } else {
            this.deleteDialog = false;
            this.deleteRecordId = null;
            this.disabledCancel = false;
            this.yesActionLoading = false;
            this.$notify({
              group: "orders",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.deleteDialog = false;
          this.deleteRecordId = null;
          this.disabledCancel = false;
          this.yesActionLoading = false;
          this.$notify({
            group: "orders",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    changeStatus(id, status) {
      if (status == 1) {
        this.newStatus = "0";
      } else {
        this.newStatus = "1";
      }
      this.statusDialog = true;
      this.statusRecordId = id;
    },
    changeStatusRecord(id, status) {
      this.yesActionLoading = true;
      this.disabledCancel = true;

      adminAPI
        .statusorder({ id: id, status: status })
        .then((response) => {
          if (response.status == "success") {
            this.statusDialog = false;
            this.statusRecordId = null;
            this.newStatus = null;
            this.yesActionLoading = false;
            this.disabledCancel = false;
            this.$notify({
              group: "orders",
              type: "success",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
            this.getOrders();
          } else {
            this.statusDialog = false;
            this.statusRecordId = null;
            this.newStatus = null;
            this.yesActionLoading = false;
            this.disabledCancel = false;
            this.$notify({
              group: "orders",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.statusDialog = false;
          this.statusRecordId = null;
          this.newStatus = null;
          this.yesActionLoading = false;
          this.disabledCancel = false;
          this.$notify({
            group: "orders",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.invite-btn {
  background-color: #3d5a80 !important;
}

.invite-btn:hover {
  background-color: #002c47 !important;
}

.new-btn-text {
  margin-left: 10px;
  font-size: 13px;
}

a {
  cursor: pointer;
}

.file-modal {
  padding: 0;
  margin: 0;
}

.modal-image {
  width: 100%;
}

.table-image {
  cursor: pointer;
}

th {
  cursor: pointer;
}

.loading-tbody {
  text-align: center;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  height: 48px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 14px;
  height: 48px;
}
.clickable-td {
  cursor: pointer;
}
</style>
